import React, { Component } from 'react';
import moment from 'moment';
import DatePicker, { registerLocale} from 'react-datepicker';
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
registerLocale('es', es);

class DatePickerForm extends Component {

    state= {
        id:"",
        text: "",
        width:"",
        offset:"",
        size:"",
        defaultValue: new Date(),
        hidden:"",
        required: false,
        showLabel: true,
        rowIndex: -1
    }
    formatDP = "dd/MM/yyyy";
    formatMoment = "DD/MM/YYYY";
    counter = 0;
    getCounter = ()=>{
        return this.counter++
    }

    //initial state
    constructor(props){
        super(props)
        this.state.id= props.data.domain;
        if(this.state.id === ''){
            this.state.id= props.data.text;
        }
        this.state.text = props.data.text;
        this.state.width = props.data.width;
        this.state.size = props.data.size;
        this.state.offset = props.data.offset;
        this.state.required = props.required;     
        this.state.hidden = props.data.hidden;
        this.state.showLabel = props.showLabel;       
        this.state.rowIndex = props.rowIndex;   
        //Initializing date
        this.state.defaultValue = new Date();
        if(props.data.defaultValue!=="" && props.data.defaultValue!==0){
            var date = moment(props.data.defaultValue, this.formatMoment, true);
            if(date.isValid()){;
                this.state.defaultValue = date.toDate();                        
            }
        }
        this.handleChange(this.state.defaultValue);
    }

    refreshDatepicker = date => {
        this.setState({defaultValue: date});
        this.handleChange(date);
    }

    handleChange = date => {        
        const options = {day:'2-digit', month:'2-digit', year:'numeric'};
        this.props.addToResult(this.state.id, date.toLocaleString('es-ES', options), this.state.rowIndex);
    };
        
    getWidthClass(width) {
        switch (width) {
            case 0:
                return "";
            case 1:
                return "col-1";
            case 2:
                return "col-2";
            case 3:
                return "col-3";
            case 4:
                return "col-4";
            case 5:
                return "col-5";
            case 6:
                return "col-6";
            case 7:
                return "col-7";
            case 8:
                return "col-8";
            case 9:
                return "col-9";
            case 10:
                return "col-10";
            case 11:
                return "col-11";
            case 12:
                return "col-12";
            default:
                //return <Input addToResult={this.addToResult} formJson={item} />
                return "";
        }                
    }

    getOffsetClass(offset) {
        switch (offset) {
            case 0:
                return "";
            case 1:
                return "offset-1";
            case 2:
                return "offset-2";
            case 3:
                return "offset-3";
            case 4:
                return "offset-4";
            case 5:
                return "offset-5";
            case 6:
                return "offset-6";
            case 7:
                return "offset-7";
            case 8:
                return "offset-8";
            case 9:
                return "offset-9";
            case 10:
                return "offset-10";
            case 11:
                return "offset-11";
            default:
                //return <Input addToResult={this.addToResult} formJson={item} />
                return "";
        }                
    }
    
    getClassElement(width, offset) {
        return this.getWidthClass(width) +" " + this.getOffsetClass(offset);
    }

    render() {
        let label;
        if (this.state.showLabel){
            label = <label htmlFor={this.state.id}>{this.state.text}</label>
        }        
        return (
            <div className={this.getClassElement(this.state.width, this.state.offset)} hidden={this.state.hidden ||''}>
                {label}         
                <div>           
                    <DatePicker
                        className= "form-control" 
                        id= {this.state.id}
                        selected={this.state.defaultValue}
                        onChange={this.refreshDatepicker}
                        locale="es"
                        dateFormat={this.formatDP}
                    />
                </div>
            </div>
        );
    }
}

export default DatePickerForm;